import script from "./correctPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./correctPage.vue?vue&type=script&lang=ts&setup=true"

import "./correctPage.vue?vue&type=style&index=0&id=c64e65b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4390a2cfce3e8645dfb3e8bd3a167747/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64e65b0"]])

export default __exports__